import React from 'react';
import styled from 'styled-components';
import userImageProfile from '../assets/userImageProfile.svg'
import { useNavigate } from "react-router-dom";

const CardProductor =
  ({
    productor,
    selectedproductor
  }) => {
    const navigate = useNavigate();

    const sendDetallePath = (productor) => {
      navigate('/productores/' + `${productor.id}`)
    }

    return (
      <DivRow style={{
        backgroundColor: selectedproductor?.id === productor.id ? 'rgb(221, 221, 221)' : '#FFFFFF'
      }}

        onClick={() => sendDetallePath(productor)}
        key={productor.index}>
        <img
          src={productor?.imagen_profile || userImageProfile}
          style={{
            width: '28px',
            height: '28px',
            borderRadius: '100%',
          }}
        />

        <Text
          selectedContact={selectedproductor}
          contact={productor}>
          {productor.name} {productor.lastname}
        </Text>

      </DivRow>
    );
  };

export default CardProductor;

const Text = styled.span`
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'};
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  height: auto;
  align-content: flex-start;
  justify-content: start;
  align-items: center;
  border-top: 1.5px solid #e1e3ea;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  cursor: pointer;
  background-color: 'transparent' ;
  transition: all 0.3s ease-in-out;
  &:hover{
      box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
      opacity: 0.5;
      will-change: transform;
  }
  &:active{
      will-change: transform;
  }
`;
